export default __webpack_public_path__ + "vico_lee_resume.pdf";